import React, { useEffect, useState } from "react";
import { Typography, FormControlLabel, FormControl, RadioGroup, Radio } from '@mui/material';
import ModalFooter from "../Modal/ModalFooter/ModalFooter";
import ModalHeader from "../Modal/ModalHeader/ModalHeader";

export default function StepTwo(props) {
    const [buttons, setButtons] = useState(
        [
            {
                'function': props.prev,
                'text': 'Précedent',
                'disabled': false,
                'color': 'error'
            },
            {
                'function': props.next,
                'text': 'Suivant',
                'disabled': true,
                'color': 'success'
            }
        ]);

    useEffect( () => {
        if(props.datas.type){
            buttons[1].disabled = false;
        }else{
            buttons[1].disabled = true;
        }
        setButtons([...buttons]);
    }, [props.datas]);

    function handleTypeChange(e){
        let datas = Object.assign({}, props.datas);
        datas[e.target.name] = e.target.value;
        props.handleChange(datas);
    }

    return (
        <>
        <ModalHeader text='Qui êtes Vous ?' />
            <Typography id="modal-modal-description" variant="p">
            De quelle catégorie relevez-vous ?
            </Typography>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <FormControl component="fieldset">
                    <RadioGroup
                        aria-label="gender"
                        defaultValue={props.datas.type}
                        name="radio-buttons-group">
                        <FormControlLabel value="agence" control={<Radio name='type' onChange={(e) => handleTypeChange(e)}/>} label="Agences et prestataires de services (par exemple, gestion immobilière, nettoyage, maintenance, réception), que ceux-ci servent ou non d’intermédiaires pour les transactions entre les hôtes et les clients potentiels sur une plateforme électronique"/>
                        <FormControlLabel value="hôte" control={<Radio name='type' onChange={(e) => handleTypeChange(e)}/>} label="Hôte particulier ou professionnel (sarl, eurl, lmp…)" />
                        <FormControlLabel value="commerçant" control={<Radio name='type' onChange={(e) => handleTypeChange(e)}/>} label="Un commerçant" />
                        <FormControlLabel value="loueur" control={<Radio name='type' onChange={(e) => handleTypeChange(e)}/>} label="Un loueur de logements à court et moyen terme" />
                    </RadioGroup>
                </FormControl>
            </Typography>
            <ModalFooter buttons={buttons}/>
        </>
    )
}